__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "order-management-ui";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@auth0/auth0-react", "2.2.4", () => (Promise.all([__webpack_require__.e(447), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(5447))))));
			register("@metrogistics/acertus-ui", "0.16.2", () => (Promise.all([__webpack_require__.e(47), __webpack_require__.e(90), __webpack_require__.e(541), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(638), __webpack_require__.e(278)]).then(() => (() => (__webpack_require__(2541))))));
			register("@mui/material", "5.15.10", () => (Promise.all([__webpack_require__.e(47), __webpack_require__.e(90), __webpack_require__.e(689), __webpack_require__.e(914), __webpack_require__.e(672)]).then(() => (() => (__webpack_require__(5070))))));
			register("axios", "1.6.7", () => (__webpack_require__.e(180).then(() => (() => (__webpack_require__(180))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(950), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(7950))))));
			register("react-router-dom", "6.22.1", () => (Promise.all([__webpack_require__.e(245), __webpack_require__.e(914), __webpack_require__.e(672)]).then(() => (() => (__webpack_require__(3245))))));
			register("react", "18.2.0", () => (__webpack_require__.e(43).then(() => (() => (__webpack_require__(5043))))));
			register("web-vitals", "2.1.4", () => (__webpack_require__.e(453).then(() => (() => (__webpack_require__(6453))))));
			initExternal(4814);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};